import { useAppDispatch } from "@/reducer";
import { pasteLocationTable } from "@/reducer/LocationTablesState";
import type { LocationTableState } from "@/reducer/LocationTablesState";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { BufferName, useLocalClipboard } from "../ManageActionPanel/LocalClipboardContext";
import { ManageActionPanel } from "../ManageActionPanel/ManageActionPanel";

type LocationTableActionPanelProps = {
  table: LocationTableState;
  clearLocationTable: () => void;
};

function LocationTableActionPanel({ table, clearLocationTable }: LocationTableActionPanelProps) {
  const dispatch = useAppDispatch();
  const { readData, storeData, hasData } = useLocalClipboard<LocationTableState>();

  const hasLocations = useMemo(() => table.groups.some((g) => !isEmpty(g.locations)), [table]);

  function copyTable() {
    storeData(BufferName.LocationTable, table);
  }

  function replaceTable() {
    const copiedTable = readData(BufferName.LocationTable);
    dispatch(
      pasteLocationTable({
        id: table.id,
        locationTable: copiedTable,
      }),
    );
  }

  return (
    <ManageActionPanel
      onCopy={copyTable}
      onReplace={replaceTable}
      onRemove={clearLocationTable}
      pastDisabled={!hasData(BufferName.LocationTable)}
      disabled={!hasLocations}
    />
  );
}

export { LocationTableActionPanel };
